export const queryKeys = {
  orgs: {
    all: () => ['orgs'] as const,
    detail: (orgId: string) => ['orgs', orgId] as const,
    members: (orgId: string) => ['orgs', orgId, 'members'] as const,
    products: (orgId: string) => ['orgs', orgId, 'products'] as const,
  },
  products: {
    detail: (productId: string) => ['products', productId] as const,
    subReqTypes: (productId: string) => ['products', productId, 'sub-requirement-types'] as const,
    recordTypes: (productId: string) => ['products', productId, 'record-types'] as const,
  },
  userRequirements: {
    all: (productId: string) => ['products', productId, 'urs'] as const,
    detail: (productId: string, id: string) => ['products', productId, 'urs', id] as const,
  },
  productRequirements: {
    all: (productId: string) => ['products', productId, 'prs'] as const,
    detail: (productId: string, id: string) => ['products', productId, 'prs', id] as const,
  },
  subRequirements: {
    all: (productId: string) => ['products', productId, 'srs'] as const,
    detail: (productId: string, id: string) => ['products', productId, 'srs', id] as const,
  },
  records: {
    all: (productId: string) => ['products', productId, 'records'] as const,
    detail: (productId: string, id: string) => ['products', productId, 'records', id] as const,
  },
  hazards: {
    all: (productId: string) => ['products', productId, 'hazards'] as const,
    detail: (productId: string, id: string) => ['products', productId, 'hazards', id] as const,
  },
  views: {
    traceMatrix: (productId: string) => ['products', productId, 'views', 'trace-matrix'] as const,
    softwareTraceMatrix: (productId: string) =>
      ['products', productId, 'views', 'software-trace-matrix'] as const,
  },
  testProtocols: {
    all: (productId: string) => ['products', productId, 'test-protocols'] as const,
    detail: (productId: string, protocolId: string) =>
      ['products', productId, 'test-protocols', protocolId] as const,
    testCases: (productId: string, protocolId: string) =>
      ['products', productId, 'test-protocols', protocolId, 'test-cases'] as const,
    coverage: (productId: string) =>
      ['products', productId, 'test-protocols', 'coverage'] as const,
  },
}
